import { z } from 'zod';

export const miriamTypeSchema = z.object({
  name: z.string(),
  commonName: z.string(),
  homepage: z.string().nullable(),
  registryIdentifier: z.string().nullable(),
  uris: z.array(z.string()),
});

export const miriamTypesSchema = z.record(z.string(), miriamTypeSchema);
